import pokemonApi from "@/api/pokemonApi";

// Creo el arreglo
export const getPokemons = () => {
  //crea un arreglo basado en este arreglo
  const pokemonsARR = Array.from(Array(650));

  return pokemonsARR.map((_, index) => index + 1);
};
// Llamamos al getPokemonOptions y mezcla el arreglo getPokemons
const getPokemonOptions = async () => {
  const mixedPokemons = getPokemons().sort(() => Math.random() - 0.5);
  console.log("que devuelve mixedPokemons", mixedPokemons);
  //Tambien mandamos a llamar el getPokemonName porque necesito los nombres de 4 pokemons
  const pokemons = await getPokemonNames(mixedPokemons.splice(0, 4));
  console.table(pokemons);
  return pokemons;
};

export const getPokemonNames = async ([a, b, c, d] = []) => {
  // const resp = await pokemonApi.get(`/3`);
  // console.log(resp.data.name, resp.data.id);

  const promiseArr = [
    pokemonApi.get(`/${a}`),
    pokemonApi.get(`/${b}`),
    pokemonApi.get(`/${c}`),
    pokemonApi.get(`/${d}`),
  ];

  const [p1, p2, p3, p4] = await Promise.all(promiseArr);
  return [
    { name: p1.data.name, id: p1.data.id },
    { name: p2.data.name, id: p2.data.id },
    { name: p3.data.name, id: p3.data.id },
    { name: p4.data.name, id: p4.data.id },
  ];

  // const resps = Promise.all(promiseArr).then((resps) => {
  //   const pokemonData = resps.map((resps) => ({
  //     name: resps.data.name,
  //     id: resps.data.id,
  //   }));
  //   console.log(pokemonData);
  // });
};

export default getPokemonOptions;
/*
Porque Fernando creo un javascript para todo el manejo de getPokemonOptions y no  un componente VUE?? En otras palabras en una aplicacion VUE en que casos deberìa usar JS puro??

  La razón por la que Fernando creó un archivo JavaScript para manejar el getPokemonOptions en lugar de un componente es porque necesitaba implementar una función que contiene lógica y no requería de ningún componente.

En una aplicación, se crean componentes Vue cuando necesitas mostrar algo en pantalla. Sin embargo, si solo necesitas implementar una función que contiene lógica, lo más recomendable es crear un archivo JavaScript, implementar tu lógica ahí y luego exportarla para poder usarla en algún componente.
 */
